import React from 'react';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { styles } from './ListItemWithIcon.css';

export type ListItemWithIconProps = {
  icon: 'Tick' | 'Error' | 'CheckboxYellow';
  content: React.ReactNode;
};

export const ListItemWithIcon = ({ icon, content }: ListItemWithIconProps) => {
  const color = {
    Tick: palette.success.main,
    Error: palette.error.main,
    CheckboxYellow: undefined,
  }[icon];

  return (
    <li className={styles.wrapper}>
      <Icon className={styles.icon} name={icon} color={color} />
      <div className={styles.content}>{content}</div>
    </li>
  );
};
